(() => {
  const init = (scope) => scope.querySelectorAll('[data-bespoke2-possibilities]').forEach((section) => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const categories = [...section.querySelectorAll('[data-bespoke2-category]')];
    const thumbs = [...section.querySelectorAll('[data-bespoke2-thumb]')];
    const image = section.querySelector('[data-bespoke2-main-image]');
    const placeholder = section.querySelector('[data-bespoke2-placeholder]');
    const badge = section.querySelector('[data-bespoke2-badge]');
    const activate = (id) => {
      const thumb = thumbs.find((item) => item.dataset.bespoke2Thumb === id);
      [...categories, ...thumbs].forEach((item) => {
        const active = (item.dataset.bespoke2Category || item.dataset.bespoke2Thumb) === id;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      if (!thumb) return;
      if (badge) badge.textContent = thumb.dataset.badge || '';
      if (!image) return;
      if (!thumb.dataset.image) {
        image.hidden = true;
        if (placeholder) placeholder.hidden = false;
        return;
      }
      image.style.opacity = '.25';
      window.setTimeout(() => {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = thumb.dataset.image;
        image.alt = thumb.dataset.alt || '';
        image.hidden = false;
        if (placeholder) placeholder.hidden = true;
        image.style.opacity = '1';
      }, 180);
    };
    categories.forEach((item) => item.addEventListener('click', () => activate(item.dataset.bespoke2Category)));
    thumbs.forEach((item) => item.addEventListener('click', () => activate(item.dataset.bespoke2Thumb)));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();


